// src/modules/app-views/goodsReceipt/service.js
// *******************************************************************************
// GOODS RECEIPT SERVICE
// *******************************************************************************
// Service layer for goods receipt operations including confirm and cancel actions.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import axiosService from 'services/axiosService';
import { API, apiUrl } from 'constants/Api';

// *******************************************************************************
// API METHODS
// *******************************************************************************

/**
 * Confirm a goods receipt entry (generates side effects: stock, payables, etc.)
 * @param {string} _id - Goods receipt document ID
 * @returns {Promise<Object>} Updated document result
 */
export const confirmGoodsReceipt = async _id => {
  const url = apiUrl.build({ url: API.GOODS_RECEIPTS.CONFIRM, params: { _id } });
  const [doc, result] = await axiosService.post({ url, returnAsObject: true });
  return result;
};

/**
 * Cancel a confirmed goods receipt (reverses side effects)
 * @param {string} _id - Goods receipt document ID
 * @returns {Promise<Object>} Updated document result
 */
export const cancelGoodsReceipt = async _id => {
  const url = apiUrl.build({ url: API.GOODS_RECEIPTS.CANCEL, params: { _id } });
  const [doc, result] = await axiosService.post({ url, returnAsObject: true });
  return result;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default {
  confirmGoodsReceipt,
  cancelGoodsReceipt,
};
